import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Lightweight placeholder rendered while a lazy-loaded route chunk or the
 * page-level data query is still pending. Purely visual — does not block
 * children. Uses a single ``aria-busy`` region so screen readers announce
 * the in-progress state exactly once.
 */
export function PageSkeleton(): ReactElement {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t('shell.pageSkeleton.label')}
      className="p-6 space-y-4"
    >
      <Skeleton className="h-8 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-4/5" />
    </div>
  );
}
